import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const usePath = () => {
  const [path, setPath] = useState([])
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/') {
      setPath([])
    } else {
      const locationArray = location.pathname.split('/').slice(1)
      setPath(locationArray)
    }
  }, [location])
  return path
}

export default usePath
